// src/App.js
import "./Styles/main.scss"; // Import the SCSS file
import "./i18n"; // Import i18n configuration
import { useTranslation } from "react-i18next";
import Main from "./Main";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/material";
import useGoogleAnalytics from "./gtag";
import { Toaster } from "sonner";
import { ThemeModeProvider, useThemeMode } from "./Styles/ThemeModeContext";

const globalStyles = (
  <GlobalStyles
    styles={{
      "html, body": {
        backgroundColor: "var(--page-bg)",
        color: "var(--text-primary)",
      },
      "::-webkit-scrollbar": {
        width: "8px", // For vertical scrollbar
      },
      "::-webkit-scrollbar-thumb": {
        backgroundColor: "var(--border-strong)",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "var(--accent)",
      },
      "::-webkit-scrollbar-track": {
        backgroundColor: "var(--surface-2)",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar:horizontal": {
        height: "8px",
      },
      "::-webkit-scrollbar-thumb:horizontal": {
        backgroundColor: "var(--border-strong)",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-track:horizontal": {
        backgroundColor: "var(--surface-2)",
        borderRadius: "4px",
      },
    }}
  />
);

function AppShell() {
  useGoogleAnalytics();
  const translations = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { mode } = useThemeMode();
  return (
    <>
      {globalStyles}
      <Toaster
        position="bottom-right"
        theme={mode}
        toastOptions={{
          style: {
            background: "var(--surface-1)",
            border: "1px solid var(--border-soft)",
            color: "var(--text-primary)",
          },
        }}
      />
      <div id="app" className="App">
        <Main location={location} navigate={navigate} translations={translations} />
      </div>
    </>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <AppShell />
    </ThemeModeProvider>
  );
}

export default App;
